var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVeicolo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 427.853,
    height: 427.853,
    viewBox: "0 0 113.203 113.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "b",
    x1: 0,
    y1: 0,
    x2: 270.933,
    y2: 270.933,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.41783 0 0 .41783 0 0)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4396c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a5eb9"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: -0.063,
    width: 1.125,
    y: -0.063,
    height: 1.125,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251,
    floodColor: "#000",
    result: "flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "composite1",
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    result: "offset"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "offset",
    result: "composite2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251,
    floodColor: "#000",
    result: "flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "composite1",
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    result: "offset"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "offset",
    result: "composite2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 0A56.602 56.602 0 000 56.602a56.602 56.602 0 000 .1 56.602 56.602 0 0056.602 56.5h.1a56.602 56.602 0 0056.5-56.6 56.602 56.602 0 000-.102A56.602 56.602 0 0056.603 0z",
    fill: "url(#b)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "normal"
    },
    d: "M511.275 173.422A338.086 338.578 0 00173.912 512 338.086 338.578 0 00512 850.578 338.086 338.578 0 00850.088 512 338.086 338.578 0 00512 173.422a338.086 338.578 0 00-.725 0zm10.403 55.496l.367.016c6.137.217 11.355 3.826 13.914 8.96a16.095 16.095 0 011.682 7.77c-.316 8.925-7.805 15.908-16.733 15.594l-.37-.014c-5.987-.211-11.097-3.649-13.72-8.582a16.106 16.106 0 01-1.875-8.15c.316-8.927 7.809-15.909 16.735-15.594zm47.064 5.934c1.075.013 2.163.133 3.254.37a282.222 282.222 0 0189.77 36.528 16.095 16.095 0 015.504 5.738c2.824 4.993 2.894 11.336-.36 16.545-4.732 7.575-14.708 9.877-22.283 5.145a250 250 0 00-79.51-32.35 16.138 16.138 0 01-10.844-8.217 16.109 16.109 0 01-1.52-11.027c1.664-7.636 8.468-12.827 15.99-12.732zm-82.719 162.64c85.136.26 151.485 61.28 154.262 63.889l2.02 1.877c3.576 1.73 14.868 5.87 49.388 12.666 48.964 9.655 58.306 25.277 60.07 31.318 3.91 2.922 10.238 9.89 11.24 18.088.807 6.538 2.636 9.214 2.636 9.207l.841 1.09v46.148l-.093.844c-2.654 12.255-15.337 18.738-36.676 18.738-6.806 0-11.911-.695-11.713-.695-.296-.016-2.926-.062-7.486-.156.466-1.291.89-2.597 1.256-3.934.354-1.29.677-2.588.927-3.918.602-3.13.944-6.35.944-9.658 0-28.36-23.043-51.435-51.362-51.435-28.318 0-51.357 23.075-51.357 51.435 0 2.565.248 5.05.607 7.516.197 1.337.426 2.666.727 3.965.308 1.344.631 2.674 1.041 3.98-64.133-1.376-145.74-3.19-208.943-4.781.278-1.299.459-2.616.636-3.946a47.36 47.36 0 00.344-3.955c.046-.928.139-1.836.139-2.779 0-28.36-23.04-51.435-51.358-51.435-27.918 0-50.665 22.44-51.298 50.26 0 .386-.06.78-.06 1.175 0 .997.09 1.97.153 2.96.078 1.405.22 2.803.405 4.179-12.068-1.994-21.145-8.362-26.399-18.662-8.988-17.611-4.408-41.456-1.182-46.52 1.742-2.74 2.607-13.45 3.377-22.896.695-8.389 1.475-17.881 2.997-26.073 1.056-5.729 3.38-13.359 11.234-13.359.787 0 1.576.078 2.353.158.486.047.972.115 1.768.13.016 0 .27-.249.594-1.19 2.306-6.616 11.981-14.844 24.388-24.909 3.057-2.47 6.717-5.446 8.276-6.98-.572-3.964-.488-8.83 2.267-12.186 1.28-1.565 3.689-3.433 7.84-3.433.61 0 1.257.038 2.7.166 2.995 0 8.997-1.237 17.308-2.957 21.428-4.404 61.316-12.61 121.123-13.9a177.09 177.09 0 014.066-.032zM354.127 539.467c23.997 0 43.459 19.482 43.459 43.521 0 .873-.085 1.72-.13 2.586a41.905 41.905 0 01-.411 3.95 47.493 47.493 0 01-.77 3.937c-4.69 18.963-21.763 33.047-42.148 33.047-21.312 0-39.006-15.384-42.709-35.654a48.451 48.451 0 01-.553-3.989 42.689 42.689 0 01-.193-3.877v-.103c.046-23.985 19.489-43.418 43.455-43.418zm308.15 0c24.005 0 43.46 19.482 43.46 43.521 0 3.261-.388 6.438-1.071 9.498a38.81 38.81 0 01-1.057 3.91 42.951 42.951 0 01-1.47 3.924c-6.694 15.409-22.006 26.188-39.854 26.188-18.488 0-34.236-11.583-40.517-27.871a44.408 44.408 0 01-1.319-3.987 45.344 45.344 0 01-.912-3.972c-.44-2.495-.719-5.065-.719-7.69 0-24.04 19.454-43.521 43.46-43.521zm-308.15 15.232c-15.578 0-28.214 12.631-28.244 28.22v.07c0 .853.047 1.688.123 2.52a31.4 31.4 0 00.36 2.59c2.406 13.176 13.908 23.176 27.761 23.176 13.25 0 24.347-9.156 27.396-21.482.2-.84.37-1.693.5-2.559.13-.844.216-1.695.266-2.564.03-.563.088-1.114.088-1.682 0-15.626-12.652-28.289-28.25-28.289zm308.15 0c-15.603 0-28.248 12.663-28.248 28.29 0 1.706.18 3.374.465 4.995a28.927 28.927 0 001.451 5.176c4.083 10.588 14.319 18.115 26.336 18.115 11.601 0 21.554-7.004 25.905-17.02a28 28 0 00.957-2.554c.273-.828.5-1.677.687-2.54a28.32 28.32 0 00.697-6.173c0-15.626-12.647-28.289-28.25-28.289z",
    transform: "translate(-8.49 -8.49) scale(.12713)",
    fill: "#fff",
    fillRule: "evenodd",
    filter: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "difference"
    },
    d: "M386.38 326.457c-4.466 0-8.72 2.249-11.376 6.02a185.702 185.702 0 01-44.815 44.834c-3.245 2.291-5.397 5.794-5.898 9.613-.503 3.822.613 7.601 3.146 10.638l15.934 18.784a225 225 0 0071.234-70.21l-19.304-16.378c-2.571-2.145-5.723-3.301-8.92-3.301z",
    transform: "scale(.25135)",
    opacity: 0.75,
    fill: "#333",
    filter: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "difference"
    },
    d: "M57.833 20.613a2.057 2.057 0 00-.145 4.11l.047.002a2.056 2.056 0 00.145-4.11zm5.984.755a2.057 2.057 0 00-.461 4.065 31.784 31.784 0 0110.108 4.113 2.056 2.056 0 102.179-3.487 35.88 35.88 0 00-11.413-4.644 2.065 2.065 0 00-.413-.047z",
    opacity: 0.75,
    fill: "#333",
    fillRule: "evenodd"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeicolo);
export default __webpack_public_path__ + "static/media/veicolo.3acc5d7a.svg";
export { ForwardRef as ReactComponent };